/**
 * Service map for the public SSO registration endpoint
 */
const provider = {};

module.exports = {
    interface_version : "1.0.0",
    create : {
        /**
         * Creates a new user entity based on verified SSO data.
         */
        sso_user : {
            requestMapSchema : {
                type : "object",
                properties : {
                    token : { type : "string" },
                    company : { type : "string" },
                    scope : { type : "string" },
                    locale : { type : "string" }
                },
                required : [ "token", "company", "scope", "locale" ],
                additionalProperties : false
            },
            handler :  [ provider, "createSsoUser" ]
        },
        /**
         * Links the sso account with the original account based on a verified password.
         */
        sso_user_with_password : {
            requestMapSchema : {
                type : "object",
                properties : {
                    token : { type : "string" },
                    password : { type : "string" },
                },
                required : [ "token", "password" ],
                additionalProperties : false
            },
            handler :  [ provider, "createSsoUserWithPassword" ]
        },
        /**
         * Exchange an SSO Artifact Code for a full Session.
         *
         */
        session_with_sso_code : {
            requestMapSchema : {
                type : "object",
                properties : {
                    code : { type : "string" },
                    scope : { type : "string" }
                },
                required : [ "code" ],
                additionalProperties : false
            },
            handler : [ provider, "createSessionWithSsoCode" ]
        },
        /**
         * Exchange SSO Artifact and Invite Token for Session.
         *
         */
        confirmed_user_with_sso : {
            requestMapSchema : {
                type : "object",
                properties : {
                    token : { type : "string" },
                    code : { type : "string" },
                    scope : { type : "string" }
                },
                required : [ "token", "code" ],
                additionalProperties : false
            },
            handler : [ provider, "createConfirmedUserWithSso" ]
        }
    },
    retrieve : {
        sso_context : {
            requestMapSchema : {
                type : "object",
                properties : {
                    token : { type : "string" }
                },
                required : [ "token" ],
                additionalProperties : false
            },
            handler : [ provider, "retrieveSsoContext" ]
        }
    },
};